import { render, staticRenderFns } from "./indexv2.vue?vue&type=template&id=04abc15a"
import script from "./indexv2.vue?vue&type=script&lang=js"
export * from "./indexv2.vue?vue&type=script&lang=js"
import style0 from "./indexv2.vue?vue&type=style&index=0&id=04abc15a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports